import React from 'react';

// 큰 물음표 — 브랜드 주황 그러데이션 말풍선(원 중심 28,27 · 반지름 24 · 왼쪽 아래 꼬리) 안의 흰 물음표.
// 물음표는 선(굵기 4.4·둥근 끝)으로 그려 가로 19~37, 세로 11~42 — 원 중심에 맞춘다. 진입 카드·회원 전용 안내가 함께 쓴다
function QuestionMark({ className, size }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 56 56" aria-hidden="true">
      <defs>
        <linearGradient id="vcq-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ff925c" />
          <stop offset="1" stopColor="#f77c40" />
        </linearGradient>
      </defs>
      <path d="M28 3a24 24 0 1 1-13.6 43.8L6 54l2.6-9.7A24 24 0 0 1 28 3z" fill="url(#vcq-grad)" />
      <path d="M21.5 20.5C21.5 16.4 24.4 13.6 28 13.6C31.7 13.6 34.6 16.3 34.6 19.8C34.6 22.4 33.2 23.9 31 25.3C29.2 26.5 28 27.9 28 30.6V32" fill="none" stroke="#ffffff" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="28" cy="39" r="2.8" fill="#ffffff" />
    </svg>
  );
}

export default QuestionMark;
